import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getConsent, setConsent, loadAnalytics } from '@/analytics';

/**
 * Asks once for analytics cookies. Accept and decline are equally prominent:
 * a decline that is harder to find than accept is not valid consent.
 */
export default function CookieBar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === 'granted') loadAnalytics();
    else if (c !== 'denied') setOpen(true);
  }, []);

  if (!open) return null;

  const choose = (value) => {
    setConsent(value);
    setOpen(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 pointer-events-none">
      <div className="pointer-events-auto mx-auto max-w-xl bg-[#1a1a1a] border border-white/15 rounded-2xl p-4 shadow-2xl">
        <p className="text-white/80 text-sm font-body leading-relaxed">
          {t('microsite.cookieText')}{' '}
          <Link to="/privacy" className="text-brand underline underline-offset-2">
            {t('microsite.privacyLink')}
          </Link>
        </p>
        <div className="flex gap-2 mt-3">
          <button
            onClick={() => choose('granted')}
            className="flex-1 bg-brand text-black font-heading font-bold uppercase text-sm px-4 py-2.5 rounded-lg"
          >
            {t('microsite.cookieAccept')}
          </button>
          <button
            onClick={() => choose('denied')}
            className="flex-1 bg-brand text-black font-heading font-bold uppercase text-sm px-4 py-2.5 rounded-lg"
          >
            {t('microsite.cookieDecline')}
          </button>
        </div>
      </div>
    </div>
  );
}
